console.log("Knowledge Generator Loaded");

function generateKnowledge(product){

    const text = (
        product.title + " " +
        product.product_type + " " +
        (product.tags || []).join(" ")
    ).toLowerCase();

    //--------------------------------------------------
    // BULB CAMERA
    //--------------------------------------------------

   //--------------------------------------------------
// BULB CAMERA
//--------------------------------------------------

if(text.includes("bulb camera")){

    return{

        aiSummary:
        "The IFITech Bulb Camera is a smart Wi-Fi CCTV camera designed to provide 360° surveillance with easy bulb socket installation. It offers remote monitoring, motion detection, night vision and two-way communication through a mobile application.",

        features:[

            "360° panoramic coverage",

            "HD video recording",

            "Wi-Fi connectivity",

            "Mobile app remote viewing",

            "Motion detection alerts",

            "Color night vision",

            "Two-way audio communication",

            "Supports microSD card recording",

            "Easy bulb socket installation",

            "Indoor surveillance"

        ],

        bestFor:[

            "Homes",

            "Apartments",

            "Living Rooms",

            "Bedrooms",

            "Kids Room",

            "Elderly Monitoring",

            "Pet Monitoring",

            "Small Shops"

        ],

        installation:
        "Screw the camera into a standard E27 bulb holder, switch on the power, download the recommended mobile application, connect the camera to your Wi-Fi network and complete the setup using the QR code.",

        warranty:"1 Year"

    };

}
    //--------------------------------------------------
    // FINGERPRINT LOCK
    //--------------------------------------------------

    if(text.includes("fingerprint")){

        return{

            aiSummary:"",
            features:[],
            bestFor:[],
            installation:"",
            warranty:"1 Year"

        };

    }

    //--------------------------------------------------

    return null;

}


function getProductKnowledge(product){

    if(!product) return null;

    // Check if custom knowledge exists
    if(PRODUCT_KNOWLEDGE[product.handle]){

        const data = PRODUCT_KNOWLEDGE[product.handle];

        // If AI Summary already exists, use it
        if(data.aiSummary && data.aiSummary.trim() !== ""){

            return data;

        }

    }

    // Otherwise generate automatically
    return generateKnowledge(product);

}